import { Card, CardContent, CardHeader, Chip, List, ListItem, Tooltip, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import Avatar from "./avatar.component";
import { LoadMessages, UpdateContact } from "../../actions";
import setToast from "../../helpers/toaster.helper";
import { Contact, Group, GroupChatModel, mapToContact } from "../../models/conversations";
import { ContactService } from "../../services/ContactService";
import Confirm_Dialog from "./confirm-dialog.component";
import { ActionLabels, appNote, buttonLabels, pageTitles, ToasterTexts, ViewTextLabels } from "./constants";
import GridOptions from "./grid-options.component";
import { ToasterType } from "./toaster/toaster.model";
import { UtilityService } from "../../services/UtilityService";
import { UserService } from "../../services/UserService";
import { AddContactPrimaryIcon, GroupChatAvatorIcon, BackMobileIcon, BlockIcon, CancelWhiteIcon, EditContactIcon, EditGroupChatIcon, TrashIcon } from "../../icon";
import GroupChatView from "../conversations/groupchat-view.component";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import * as selector from '../../selectors/selectors'

interface IDispatchProps {
    UpdateContact: (contact: Contact) => void;
    LoadContacts: () => void;
    LoadMessages: () => void;
}

interface Props {
    openContactInfo: boolean;
    handleContactClose: () => void;
    handleEditContact?: () => void;
    Contact?: Contact;
    IsMobileDevice: boolean;
    groupChatInfo?: GroupChatModel;
    groupInfo?: boolean;
    SelectedGroup?: Contact[];
    handleEditGroupChat?: (e: any) => void;
    GroupName?: string;
}

const ContactDetails = (props: Props) => {
    const dispatch = useDispatch()
    const Groups: Group[] = useSelector(selector.groups);
    const Contacts: Contact[] = useSelector(selector.contacts);
    const IsDarkMode: boolean = useSelector(selector.isDarkMode);
    const [show, setShow] = useState<boolean>()
    const [text, setText] = useState<string>()
    const [dialogAction, setDailogAction] = useState<string>()
    const [buttonName, setButtonName] = useState<string>()
    const [contact, setContact] = useState<Contact>()
    const [isLoading, setIsLoading] = useState<boolean>()
    const [openEditGroupChatName, setopenEditGroupChatName] = useState<boolean>()


    const openConfirmDialog = () => {
        setShow(true)
        setText(appNote.CONTACT_DELETE)
        setDailogAction("Delete")
        setButtonName("Delete")
        setIsLoading(false)
    }

    const openBlockConfirmDialog = (Id: string, isBlocked: boolean) => {
        let text = isBlocked ? appNote.UNBLOCK_CONTACT : appNote.BLOCK_CONTACT;
        setShow(true)
        setText(text)
        setDailogAction("Blocked")
        setButtonName(isBlocked ? 'UnBlock' : 'Block')
        setIsLoading(false)

    }
    const handleKeyUp = (event: any) => {
        if (event.key === "Escape") {
            props.handleContactClose?.call(props);
        }
    }

    const closeConfirmDialog = (isConfim: any) => {
        var action = dialogAction;
        if (!!isConfim && (action == "Delete" || action == "Blocked")) {
            var row = props.Contact;
            let Name = row.Name ? row.Name : row.PhoneNumber;
            setIsLoading(true)
            var apiCall = (action == "Delete")
                ? ContactService.deleteContact(props.Contact.ID, false)
                : ContactService.blockUnBlockNumber(props.Contact.PhoneNumber.replace('+', ''), !props.Contact.IsBlocked)
            apiCall.then((res) => {
                if (action == "Delete") {
                    LoadMessages(dispatch);
                    setToast(ToasterTexts.CONTACT_DELETE_SUCCESS.replace('<Name>', Name), ToasterType.SUCCESS)
                }
                else {
                    setToast(!props.Contact.IsBlocked ? ToasterTexts.CONTACT_BLOCK_SUCCESS.replace('<Name>', Name) : ToasterTexts.CONTACT_UNBLOCK_SUCCESS.replace('<Name>', Name), ToasterType.SUCCESS)
                }
                setShow(false)
                setText("")
                setDailogAction("")

            });
        } else {
            setShow(false)
            setText("")
            setDailogAction("")
            setIsLoading(false)
        }
    };

    const trimContactName = (fname: string, lname: string) => {
        let Name = "";
        if ((fname !== null && lname !== null)) {
            if (fname?.length > 18) {
                fname = fname.substring(0, 18) + "...\n"
            }
            if (lname?.length > 18) {
                lname = lname.substring(0, 18) + "..."
            }
            Name = (fname + " ") + lname
        }
        else {
            let lastname = !!lname ? lname : ""
            Name = fname + " " + lastname
        }
        return Name
    }


    const trimEmail = (email: string) => {
        let result = ""
        if (email?.length > 30) {
            let [first, second] = email?.split('@')
            result = result.concat(first.length > 12 ? first.substring(0, 12) + "..." : first)
            result = result.concat("@")
            result = result.concat(second)
        } else {
            result = email
        }
        return result
    }

    const getContact = (number) => {
        let contact = Contacts.find(contact => contact.PhoneNumber === number && contact.Name)
        return UserService.getUserPhoneNumber() === number ? "You" : !!contact ? UtilityService.trimMessage(contact.Name, 20) : "--"
    }

    const { Contact } = props;
    const dataWithId = [
        {
            btnName: ActionLabels.EDIT_CONTACT,
            btnColor: "color-conv-hist-menu",
            btnIcon: EditContactIcon,
            onClickbtn: () => props.handleEditContact(),
        },
        {
            btnName: !!Contact?.IsBlocked ? ActionLabels.UNBLOCK_CONTACT : ActionLabels.BLOCK_CONTACT,
            btnColor: "color-conv-hist-menu",
            btnIcon: !!Contact?.IsBlocked ? BlockIcon : BlockIcon,
            onClickbtn: () => openBlockConfirmDialog(Contact?.ID || "", Contact?.IsBlocked || false),
        },
        {
            btnName: ActionLabels.DELETE_CONTACT,
            btnColor: "color-conv-hist-menu",
            btnIcon: TrashIcon,
            onClickbtn: () => openConfirmDialog(),
        },
    ];
    const GroupChatButtonData = [
        {
            btnName: ActionLabels.EDIT_GROUP_CHAT,
            btnColor: "color-conv-hist-menu",
            btnIcon: EditGroupChatIcon,
            // onClickbtn: () => this.props.handleEditContact(),
        },
        {
            btnName: ActionLabels.DELETE_CONVERSATION,
            btnColor: "color-conv-hist-menu",
            btnIcon: TrashIcon,
            // onClickbtn: () => this.openBlockConfirmDialog(Contact?.ID || "", Contact?.IsBlocked || false),
        },
    ];
    const dataWithoutId = [
        {
            btnName: buttonLabels.ADD_CONTACT,
            btnColor: "color-conv-hist-menu",
            btnIcon: AddContactPrimaryIcon,
            onClickbtn: () => props.handleEditContact(),
        },
        {
            btnName: !!props.Contact?.IsBlocked ? ActionLabels.UNBLOCK_CONTACT : ActionLabels.BLOCK_CONTACT,
            btnColor: "color-conv-hist-menu",
            btnIcon: BlockIcon,
            onClickbtn: () => openBlockConfirmDialog(props.Contact.PhoneNumber.replace('+', '') || "", props.Contact.IsBlocked || false),
        },
    ];

    const handleEditGroupName = () => {
        setopenEditGroupChatName(true)
    }

    const handleCloseEditGroupchatname = () => {
        setopenEditGroupChatName(false)
    }

    return (
        <>
            {props.openContactInfo && props.IsMobileDevice ?
                <div className={`w-fill ${IsDarkMode ? "bg-color-sidebar-bg" : "paper-background"}  h-v-100 w-p-100`}>
                    <div className={'py-2 pr-2 pl-1 d-flex box-shadow-display-background-shadow'}>
                        <span className={"c-pointer mr-1 my-auto"}><BackMobileIcon onClick={props.handleContactClose} /></span>
                        <span className="f-label-input my-auto h3 w-break">{!!props.groupChatInfo ? pageTitles.GROUP_CHAT_INFORMATION : props.groupInfo ? props?.GroupName : pageTitles.CONTACT_INFO}</span>
                    </div>
                    <div className={`${props.groupInfo ? "p-2" : "p-4"}`}>
                        {!props.groupInfo &&
                            <div className="d-flex">
                                <div>
                                    {
                                        !!props.groupChatInfo ? <div className="w-5 h-5 d-flex align-center justify-center bg-color-groupchat-avator-icon-bg br-50"><GroupChatAvatorIcon /></div> : <Avatar Name={props.Contact.Name} />
                                    }
                                </div>
                                <span className={`h3-bold color-primary-accent opacity-2 ml-1 my-auto ${!!props.groupChatInfo ? "w-break" : ""}`}>
                                    {
                                        !!props.groupChatInfo?.Name ?
                                            props.groupChatInfo?.Name :
                                            props.groupChatInfo?.PhoneNumbers ?
                                                `${props.groupChatInfo?.PhoneNumbers.length}  people` :
                                                (Contact && Contact.Name) ? trimContactName(Contact.FirstName, Contact.LastName) :
                                                    props.Contact.MaskedPhoneNumber
                                    }
                                </span>
                            </div>
                        }

                        {props.groupInfo &&
                            <>
                                <div className="o-y-scroll h-v-90">
                                    <div className="d-flex justify-between h3">
                                        <div className="w-15">Name</div>
                                        <div className="w-15">Phone Number</div>
                                        <div className='w-10'>Status</div>
                                    </div>
                                    {
                                        props.SelectedGroup?.map(data => (
                                            <div className="py-1 d-flex justify-between h6-regular align-center">
                                                <div className="w-15 w-break">{UtilityService.trimMessage(data.Name, 30)}</div>
                                                <div className="w-15">{UtilityService.maskPhoneNumberOnLength(data.PhoneNumber)}</div>
                                                <div className={`w-10 color-secondary ${data.IsUnsubscribed ? "color-contact-unsubscribed" : data.IsBlocked ? "color-contact-blocked" : "color-contact-active"}`}>{data.IsUnsubscribed ? "Unsubscribed " : data.IsBlocked ? "Blocked" : "Active"}</div>
                                            </div>
                                        )
                                        )
                                    }
                                </div>
                            </>
                        }

                        {
                            !!props.groupChatInfo ?
                                <div className="py-1 d-flex justify-between mt-1">
                                    <span className="h6-regular d-flex justify-center">Name</span>
                                    <span className="h6-regular">{ViewTextLabels.PHONE_NUMBERS}</span>
                                </div> : props.groupInfo ? null :
                                    <Typography variant="subtitle2" className="h4-regular mt-2">{!!props.groupChatInfo ? ViewTextLabels.PHONE_NUMBERS : ViewTextLabels.PHONE_NUMBER}</Typography>
                        }
                        {
                            !!props.groupChatInfo ?
                                <div className="br-1">
                                    <div className="py-1">
                                        {
                                            props.groupChatInfo?.PhoneNumbers.map(number => (
                                                <div className="py-1 d-flex justify-between">
                                                    <span className="h6-regular d-flex justify-center ">{getContact(number)}</span> <span className="h6-regular">{UtilityService.maskPhoneNumberOnLength(number)}</span>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div> : props.groupInfo ? null :
                                    <Typography variant="body2" className={`my-2 mx-0 color-primary', notchedOutline:'br-text-field py-1 pr-3 pl-1 w-p-90 h4-regular color-primary opacity-4`}>
                                        {props.Contact.MaskedPhoneNumber || UtilityService.maskPhoneNumberOnLength(props.Contact?.PhoneNumber)}
                                    </Typography>
                        }
                        {
                            (!!props.groupChatInfo || !!props.groupInfo) ?
                                null :
                                <>
                                    <Typography variant="subtitle2" className="h3-regular ">
                                        {ViewTextLabels.EMAIL_ID}
                                    </Typography>
                                    <Typography variant="body2" className="my-2 mx-0 color-primary', notchedOutline:'br-text-field py-1 pr-3 pl-1 w-p-90 h4-regular color-primary opacity-4 ">
                                        {Contact?.Email ? trimEmail(Contact.Email) : "--"}
                                    </Typography>
                                    <Typography variant="body2" className="h3-regular ">
                                        {ViewTextLabels.GROUPS}
                                    </Typography >
                                    {(props.Contact?.Groups && props.Contact?.Groups.length) ? <div className="h-v-10 o-y-auto"> {props.Contact?.Groups?.map((data: Group) => {
                                        return (<Chip size="small" className="mt-2 m-1 bg-color-contact-info-group-chip color-secondary" classes={{ label: "p-1" }} key={data.ID} label={data.Name} />)
                                    })}</div> : <Typography variant="body2" className="my-2 mx-0 color-primary', notchedOutline:'br-text-field py-1 pr-3 pl-1 w-p-90 h4-regular color-primary opacity-4 ">
                                        {"--"}
                                    </Typography>}
                                </>
                        }
                        {
                            (!!props.groupChatInfo || !!props.groupInfo) ? null : <List className="mt-12">
                                <ListItem className={"px-1 py-1 h4"} button onClick={() => props.handleEditContact()}>
                                    <EditContactIcon className={"mr-1"} />
                                    {Contact?.ID ? ActionLabels.EDIT_CONTACT : buttonLabels.ADD_CONTACT}
                                </ListItem>
                                <ListItem className={"px-1 py-1 h4"} onClick={() => Contact?.ID ? openBlockConfirmDialog(Contact?.ID || "", Contact?.IsBlocked || false) : openBlockConfirmDialog(props.Contact.PhoneNumber.replace('+', '') || "", props.Contact.IsBlocked || false)}  >
                                    <BlockIcon className={"mr-1"} />
                                    {Contact?.ID ? !!Contact?.IsBlocked ? ActionLabels.UNBLOCK_CONTACT : ActionLabels.BLOCK_CONTACT : !!props.Contact.IsBlocked ? ActionLabels.UNBLOCK_CONTACT : ActionLabels.BLOCK_CONTACT}
                                </ListItem>
                                {Contact?.ID && <ListItem className={"px-1 py-1 h4"} onClick={() => openConfirmDialog()}  >
                                    <TrashIcon className={"mr-1"} />
                                    {ActionLabels.DELETE_CONTACT}
                                </ListItem>}
                            </List>
                        }
                        {!!props.groupChatInfo ?
                            <div>
                                <ListItem className={"px-1 py-1 h4"} button onClick={handleEditGroupName}>
                                    <EditContactIcon className={"mr-1"} />
                                    {!!props.groupChatInfo.Name ? "Edit GroupChat Name" : "Add Groupchat Name"}
                                </ListItem>
                            </div>
                            : null
                        }
                        {
                            openEditGroupChatName && <GroupChatView
                                show={openEditGroupChatName}
                                onClose={handleCloseEditGroupchatname}
                                Groupchat={props.groupChatInfo} />
                        }
                    </div>
                </div> :
                <Card onKeyUp={handleKeyUp} className="br-2">
                    <div className="d-flex px-2 py-1 my-auto bg-color-primary-light justify-between align-center"><span className="h4-regular color-secondary w-break px-1">{props.groupChatInfo ? pageTitles.GROUP_CHAT_INFORMATION : props.groupInfo ? props.GroupName : pageTitles.CONTACT_INFO}</span>
                        <Tooltip title='Close' placement='bottom'>
                            <CancelWhiteIcon className="c-pointer ml-auto my-auto" tabIndex={2} onClick={props.handleContactClose} />
                        </Tooltip></div>
                    {!props.groupInfo && !props.groupChatInfo && <CardHeader
                        avatar={
                            <Avatar Name={props.Contact.Name} Size={60} PhoneNumber={props.Contact.PhoneNumber} />
                        }
                        action={
                            <>
                                <div className="mt-2 mr-1">
                                    {Contact?.ID ? <GridOptions data={dataWithId} /> : <GridOptions data={dataWithoutId} />}
                                </div>
                            </>
                        }

                        title={
                            <>
                                <Typography className="h3-bold color-primary-accent ">{props.Contact.MaskedPhoneNumber}</Typography>
                            </>
                        }
                        style={{ justifyContent: "center", display: "flex", wordBreak: "break-all" }}
                    />}
                    <CardContent>
                        {
                            props.groupChatInfo?.ID ?
                                <>
                                    <Typography color="initial" className="h6-regular color-text-field-label">Participants and Phone Numbers</Typography>
                                    <div className="groupchat-info-background groupchat-info-border br-1">
                                        <div className="py-1 px-2 o-y-scroll h-v-30">
                                            {
                                                props.groupChatInfo?.PhoneNumbers.map(number => (
                                                    <div className="py-1 d-flex justify-between">
                                                        <div className="h6-regular">{getContact(number)}</div> <div className="h6-regular">{UtilityService.maskPhoneNumberOnLength(number)}</div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                    {/* <div className="d-flex align-items mt-2">
                                        <img src={LeaveGroupChat} />
                                        <span className="leave-this-group-color h4-regular ml-1">Leave the group</span>
                                    </div> */}
                                </>
                                :
                                props.groupInfo ?
                                    <>
                                        <div className="groupchat-info-background groupchat-info-border br-1">
                                            <div className="py-1 px-2 o-y-scroll h-v-30">
                                                <div className="d-flex justify-between h4-regular ">
                                                    <div className="w-10">Name</div>
                                                    <div className="w-20">Phone Number</div>
                                                    <div className='w-10'>Status</div>
                                                </div>
                                                {
                                                    props.SelectedGroup?.map(data => (
                                                        <div className="py-1 d-flex justify-between h6-regular ">
                                                            <div className="w-10 w-break">{UtilityService.trimMessage(data.Name, 10)}</div>
                                                            <div className="w-20">{UtilityService.maskPhoneNumberOnLength(data.PhoneNumber)}</div>
                                                            <div className={`w-10 color-secondary ${data.IsUnsubscribed ? "color-contact-unsubscribed" : data.IsBlocked ? "color-contact-blocked" : "color-contact-active"}`}>{data.IsUnsubscribed ? "Unsubscribed " : data.IsBlocked ? "Blocked" : "Active"}</div>
                                                        </div>
                                                    )
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <>
                                        <Typography variant="subtitle2" className="h5-regular ">
                                            {ViewTextLabels.PHONE_NUMBER}
                                        </Typography>
                                        <Typography variant="body2" className="my-1 mx-0 color-text-field-font', notchedOutline:'br-text-field p-1 w-p-90 h6-regular color-primary opacity-4">
                                            {props.Contact.MaskedPhoneNumber || UtilityService.maskPhoneNumberOnLength(props.Contact?.PhoneNumber)}
                                        </Typography>

                                        <Typography variant="subtitle2" className="h5-regular ">
                                            {ViewTextLabels.EMAIL_ID}
                                        </Typography>
                                        <Typography variant="body2" className="my-1 mx-0 color-text-field-font', notchedOutline:'br-text-field w-break p-1 w-p-90 h6-regular color-primary opacity-4">
                                            {Contact?.Email ? Contact.Email : "--"}
                                        </Typography>

                                        <Typography variant="body2" className="h5-regular ">
                                            {ViewTextLabels.GROUPS}
                                        </Typography >
                                        {(props.Contact?.Groups && props.Contact?.Groups.length) ?
                                            <div className={"h-v-10 o-y-auto"}>{props.Contact?.Groups?.map((data: Group) => {
                                                return (<Chip size="small" className="mt-2 m-1 bg-color-contact-info-group-chip color-secondary" key={data.ID} label={data.Name} />)
                                            })}</div> : <Typography variant="body2" className="my-2 mx-0 color-text-field-font', notchedOutline:'br-text-field py-1 pr-1 pl-1 w-p-90 h6-regular color-primary opacity-4 ">
                                                {"--"}
                                            </Typography>
                                        }
                                    </>
                        }

                    </CardContent>
                </Card>
            }
            <Confirm_Dialog onClose={(e: any) => { closeConfirmDialog(e); !props.IsMobileDevice && props.handleContactClose?.call(props); }} Show={show} Text={text} ButtonName={buttonName} IsMobileDevice={props.IsMobileDevice} Loading={isLoading} />
        </>
    )
}


export default ContactDetails;